import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { Language } from './language.interface';
import { LanguageService } from './language.service';

const service = new LanguageService();

export interface LanguageState {
   communicationLanguages: Array<Language>;
   languages: Array<Language>;
}

const LanguageStore: Module<LanguageState, StoreState> = {
   namespaced: true,
   state: {
      communicationLanguages: [],
      languages: [],
   },
   getters: {
      communicationLanguages: (state) => state.communicationLanguages,
   },
   mutations: {
      SET_COMMUNICATION_LANGUAGES(state, communicationLanguages: Array<Language>) {
         const sortLanguages = ['NL', 'FR', 'EN'];
         state.communicationLanguages = communicationLanguages.sort((prevLang, curLang) => {
            const indexA = sortLanguages.findIndex((s) => s === prevLang.iso_639_1);
            const indexB = sortLanguages.findIndex((s) => s === curLang.iso_639_1);

            return indexA - indexB;
         });
      },
      SET_LANGUAGES(state, languages: Array<Language>) {
         state.languages = languages;
      },
   },
   actions: {
      async searchLanguages(context, query: LocationQuery) {
         return service.getLanguages({ ...query, per_page: '9999', page: '1' }).then((response) => response.data);
      },
      async getCommunicationLanguages(context, query: LocationQuery) {
         const response = await service.getLanguages({
            ...query,
            per_page: '9999',
            page: '1',
            'filter[is_communication_language]': 'true',
         });
         context.commit('SET_LANGUAGES', response.data);
         context.commit(
            'SET_COMMUNICATION_LANGUAGES',
            response.data.filter((lang) => lang.is_communication_language),
         );
         return response;
      },
      async getLanguages(context, query: LocationQuery) {
         const response = await service.getLanguages({
            ...query,
            per_page: '9999',
            page: '1',
         });
         context.commit('SET_LANGUAGES', response.data);
         context.commit(
            'SET_COMMUNICATION_LANGUAGES',
            response.data.filter((lang) => lang.is_communication_language),
         );
         return response.data;
      },
   },
};

export default LanguageStore;
